// Canonical element palette. Single source of truth — CSS vars on :root are
// injected from this map at module load (see injectElementVars below), so
// any --element-{name} consumer in CSS stays in lockstep with elementColor().
//
// Hue rule: every near-neighbor pair sits in a different hue family. Notably:
//   brute (deep red) vs earth (warm brown) — blood/iron vs soil/clay
//   holy (cream)     vs lightning (yellow) — divine light vs electric
//   wind (sky cyan)  vs finesse (steel-blue) vs nature (leaf green)
const ELEMENT_COLORS: Record<string, string> = {
  fire: '#ff5533',
  water: '#44aaff',
  lightning: '#ffe033',
  nature: '#3ad26a',
  wind: '#9be8ff',
  earth: '#a47744',
  brute: '#c0392b',
  holy: '#fff5cc',
  dark: '#a050ff',
  astral: '#d090ff',
  steel: '#c0c0c0',
  finesse: '#7aa8d8',
  physical: '#cccccc',
  blood: '#cc2244',
  time: '#88aacc',
};

export function elementColor(element: string): string {
  return ELEMENT_COLORS[element.toLowerCase()] ?? '#cccccc';
}

export const ELEMENT_COLOR_MAP: Readonly<Record<string, string>> = ELEMENT_COLORS;

function injectElementVars(): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  for (const [name, hex] of Object.entries(ELEMENT_COLORS)) {
    root.style.setProperty(`--element-${name}`, hex);
  }
}

injectElementVars();
